import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postFeedAdViewClickById,
  type PostFeedAdViewClickByIdParams,
  type PostFeedAdViewClickByIdResponse,
} from '@services/FeedAdService';

export type UsePostFeedAdViewClickByIdParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostFeedAdViewClickByIdResponse,
    unknown,
    string,
    PostFeedAdViewClickByIdParams,
    PostFeedAdViewClickByIdResponse
  >;
};

export const postFeedAdViewClickByIdMutationKey =
  'post-feed-ad-view-click-by-id';

export const usePostFeedAdViewClickById = ({
  mutationOptions,
}: UsePostFeedAdViewClickByIdParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostFeedAdViewClickByIdResponse,
    unknown,
    string,
    PostFeedAdViewClickByIdParams
  >(
    postFeedAdViewClickByIdMutationKey,
    (_url, { arg }) => postFeedAdViewClickById(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
